module.exports = __webpack_public_path__ + "img/covidnames_og.a544b2e6.jpg";